import {GetterTree} from 'vuex';
import {State} from './state';
import {SearchResult} from "@/apps/SearchWidget/models/search-result-model";

export default <GetterTree<State, any>>{
    labels(state: State): {} {
        return state.config.labels;
    },

    language(state: State): string {
        let languageFilter = state.fixedFilters?.Language;
        let language = languageFilter?.Values[0];

        return language ?? "EN";
    },

    componentType(state) {
        if (state.config.index == 'pure-data-index') {
            return 'Scientists'
        } else {
            return 'VUSearch'
        }
    },

    searchResults(state: State): SearchResult[] {
        return state.searchResults;
    },

    searchResultsCount(state: State): number {
        return state.searchResultsCount;
    },

    searchLoading(state: State): boolean {
        return state.searchLoading;
    },

    searchFailed(state: State): boolean {
        return state.searchFailed;
    },
}
